export function storeInSessionStorage(key, value) {
  const parseValue = JSON.stringify(value);
  sessionStorage.setItem(key, parseValue);
}

export function retrieveFromSessionStorage(key) {
  const value = sessionStorage.getItem(key);

  if (value) {
    const result = JSON.parse(value);
    return result;
  }
}

export function removeFromSessionStorage(key) {
  sessionStorage.removeItem(key);
}
